import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPage.css';

const InfoItem = ({ label, value }) => (
  <div className="policy-definition-item">
    <dt>{label}</dt>
    <dd>{value}</dd>
  </div>
);

const CompanyInfo = () => {
  return (
    <main className="policy-page">
      <article className="policy-document">
        <header className="policy-header">
          <p className="policy-eyebrow">회사 안내</p>
          <h1 className="policy-title">회사 정보</h1>
          <p className="policy-subtitle">
            왓퀴즈를 운영하는 플랙티컬 주식회사의 정보를 안내해요.
          </p>
        </header>

        <section className="policy-section">
          <h2>왓퀴즈 소개</h2>
          <p>
            왓퀴즈는 AI 기술을 활용하여 교육자와 학습자가 효과적으로 퀴즈와 학습 자료를 생성할 수 있도록
            도와주는 혁신적인 교육 플랫폼입니다. 교사들의 업무 효율성을 높이고, 학생들의 학습 경험을
            향상시키는 것이 우리의 목표입니다.
          </p>
        </section>

        <section className="policy-section">
          <h2>사업자 정보</h2>
          <div className="policy-info-grid">
            <div className="policy-info-card">
              <dl className="policy-definition-list">
                <InfoItem label="상호명" value="플랙티컬 주식회사" />
                <InfoItem label="사업자등록번호" value="853-81-03114" />
                <InfoItem label="대표자명" value="강연구" />
                <InfoItem label="통신판매업 신고번호" value="2024-충남천안-0144" />
              </dl>
            </div>
            <div className="policy-info-card">
              <dl className="policy-definition-list">
                <InfoItem
                  label="사업장 주소"
                  value="서울특별시 노원구 공릉로 232, 404호 제1창업보육센터(공릉동, 서울과학기술대학교)"
                />
                <InfoItem label="대표 전화" value="02-949-9158" />
                <InfoItem label="대표 이메일" value="angel@plactical.com" />
              </dl>
            </div>
          </div>
        </section>

        <section className="policy-section">
          <h2>고객 지원</h2>
          <div className="policy-card">
            <dl className="policy-definition-list">
              <InfoItem
                label="전화 상담"
                value="월~금 09:00~12:00 / 13:00~18:00 (주말, 공휴일 휴무)"
              />
              <InfoItem label="이메일 상담" value="연중무휴 09:00~23:00" />
              <InfoItem label="고객센터 이메일" value="angel@plactical.com" />
            </dl>
          </div>
        </section>

        <section className="policy-section">
          <h2>개인정보보호</h2>
          <div className="policy-card policy-card--info">
            <dl className="policy-definition-list">
              <InfoItem
                label="개인정보보호책임자"
                value="강연구 (angel@plactical.com)"
              />
            </dl>
            <p>개인정보 처리와 관련된 문의사항은 언제든지 연락주시기 바랍니다.</p>
          </div>
        </section>

        <nav className="policy-related" aria-label="관련 정책 및 약관">
          <p className="policy-related-label">관련 정책 및 약관</p>
          <div className="policy-related-links">
            <Link to="/privacy-policy" className="policy-link">개인정보처리방침</Link>
            <Link to="/terms-of-service" className="policy-link">이용약관</Link>
            <Link to="/refund-policy" className="policy-link">환불정책</Link>
          </div>
        </nav>
      </article>
    </main>
  );
};

export default CompanyInfo;
